import React from 'react'

import {PoweredBySection, PoweredByLogo} from './BookingsPortalPage.styled'

import {Typography} from '~/components/general/typography/Typography'

type PoweredByProps = {
  poweredByLabel: string
}

export const PoweredBy: React.FC<PoweredByProps> = ({poweredByLabel}) => (
  <PoweredBySection>
    <PoweredByLogo
      src="https://cushla.io/images/logo-simple.svg"
      alt="Cushla"
    />
    <Typography>
      {poweredByLabel}{' '}
      <a href="https://cushla.io" target="_blank" rel="noreferrer">
        Cushla
      </a>
    </Typography>
    <Typography color="muted">© {new Date().getFullYear()} Cushla</Typography>
  </PoweredBySection>
)
